import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {setShowLoginModal} from '../screens/Login/redux/login.action';
import {useNavigation} from '@react-navigation/native';

const ProtectedRoute = ({children}) => {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const isAppLogin = useSelector(({utilReducer}) => utilReducer.isAppLogin);
  const showLoginModal = useSelector(({login}) => login.showLoginModal);
  const isLoading = useSelector(({LoaderReducer}) => LoaderReducer.loader);
  const magicLinkAuthLoading = useSelector(({login}) => login.magicLinkAuthLoading);

  useEffect(() => {
    let timeoutId;
    
    // Only show login modal if:
    // 1. User is not logged in
    // 2. Modal is not already showing
    // 3. Initial loading is complete
    // 4. Magic link auth is not in progress
    // 5. Add a small delay to prevent flash
    if (!isAppLogin && !showLoginModal && !isLoading && !magicLinkAuthLoading) {
      timeoutId = setTimeout(() => {
        dispatch(setShowLoginModal(true));
      }, 100);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isAppLogin, showLoginModal, isLoading, magicLinkAuthLoading]);

  // If not logged in, still render children but modal will be shown
  return children;
};

export default ProtectedRoute; 